import React from 'react';
import { Link } from 'react-router-dom';
import { SEO, SEOConfig } from './SEO';
import { MainFooter } from './Footer';
import { Header } from './Header';

const DatenschutzPage = () => {
  return (
    <>
      <SEO {...SEOConfig.datenschutz} />
      <div className="min-h-screen bg-white">
        <Header />

        {/* Main Content */}
        <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
          {/* Page Header */}
          <div className="text-center mb-32">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Datenschutzerklärung
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-teal-700 to-blue-500 mx-auto mb-6"></div>
            <p className="text-lg text-gray-700">
              EnBet-Consulting UG - IDA Platform
            </p>
          </div>

          {/* Content */}
          <div>
            <div className="prose prose-lg max-w-none">

                <div className="border-l-4 border-gray-300 p-4 mb-6">
                  <p className="text-sm text-gray-700">
                    <strong>Stand:</strong> {new Date().toLocaleDateString('de-DE')} – Gilt für B2B-Kunden (Unternehmer gem. § 14 BGB)
                  </p>
                </div>

                {/* 1. Verantwortlicher */}
                <section className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    1. Verantwortlicher
                  </h2>
                  <div className="space-y-2 text-gray-700">
                    <p><strong>EnBet-Consulting UG (haftungsbeschränkt)</strong></p>
                    <p>Im Tal 30, 34270 Schauenburg</p>
                    <p>Geschäftsführer: Sebastian Funke</p>
                    <p>E-Mail: <a href="mailto:info@idaki.de" className="text-blue-600 hover:underline">info@idaki.de</a></p>
                    <p>Telefon: <a href="tel:+4917623943896" className="text-blue-600 hover:underline">+49 (0) 176 23 94 38 96</a></p>
                    <p>Umsatzsteuer-ID: DE346037206</p>
                  </div>
                </section>

                {/* 2. Geltungsbereich */}
                <section className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    2. Geltungsbereich
                  </h2>
                  <div className="space-y-4 text-gray-700">
                    <p>Diese Datenschutzerklärung gilt für die Website <strong>idaki.de</strong> und die SaaS-Plattform <strong>IDA</strong>.</p>
                    <p>Unser Angebot richtet sich ausschließlich an <strong>Unternehmer</strong> im Sinne des § 14 BGB. Verbraucher sind von der Nutzung ausgeschlossen.</p>
                  </div>
                </section>

                {/* 3. Keine Cookies oder Tracking */}
                <section className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    3. Cookies und Tracking
                  </h2>
                  <div className="border-l-4 border-gray-300 p-4">
                    <p className="text-gray-700">
                      <strong>Gute Nachricht:</strong> Unsere Website verwendet <strong>keine Cookies</strong> und setzt <strong>keine Tracking-Tools</strong> ein (kein Google Analytics, Facebook Pixel, etc.).
                    </p>
                    <p className="text-gray-700 mt-2">
                      Es erfolgt keine Verhaltensanalyse oder Profiling. Ihre Nutzung der Website wird nicht getrackt.
                    </p>
                  </div>
                </section>

                {/* 4. Verarbeitung personenbezogener Daten */}
                <section className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    4. Verarbeitung personenbezogener Daten
                  </h2>

                  <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">4.1 Kontaktformulare & Demo-Anfragen</h3>
                  <div className="space-y-3 text-gray-700">
                    <p><strong>Erhobene Daten:</strong></p>
                    <ul className="list-disc list-inside ml-4">
                      <li>Vor- und Nachname</li>
                      <li>E-Mail-Adresse</li>
                      <li>Telefonnummer</li>
                      <li>Unternehmensname</li>
                      <li>Branche</li>
                      <li>Anzahl Mitarbeiter/Standorte (optional)</li>
                      <li>IP-Adresse (technisch erforderlich)</li>
                      <li>Zeitstempel der Anfrage</li>
                    </ul>
                    <p><strong>Zweck:</strong> Bearbeitung Ihrer Anfrage, Kontaktaufnahme, Angebotserstellung</p>
                    <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen)</p>
                    <p><strong>Speicherdauer:</strong> Bis zur vollständigen Bearbeitung Ihrer Anfrage + 6 Monate; bei Vertragsabschluss gelten gesetzliche Aufbewahrungsfristen</p>
                  </div>

                  <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">4.2 Bedarfsanalyse (10-Fragen-Test)</h3>
                  <div className="space-y-3 text-gray-700">
                    <p><strong>Erhobene Daten:</strong> Ihre Antworten auf die 10 Fragen, optionale Kontaktdaten</p>
                    <p><strong>Zweck:</strong> Erstellung einer personalisierten Empfehlung, ggf. Kontaktaufnahme</p>
                    <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen)</p>
                    <p><strong>Speicherdauer:</strong> 12 Monate</p>
                  </div>

                  <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">4.3 Spieler-Selbsttest (Risk-Reward-Game)</h3>
                  <div className="space-y-3 text-gray-700">
                    <p><strong>Erhobene Daten:</strong> Spielname (pseudonym möglich), Spielergebnisse, optional E-Mail für Report-Versand</p>
                    <p><strong>Zweck:</strong> Bereitstellung des Selbsttests, optionaler E-Mail-Versand des Reports</p>
                    <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) bzw. lit. b (Vertragserfüllung)</p>
                    <p><strong>Speicherdauer:</strong> 90 Tage</p>
                  </div>

                  <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">4.4 Buchung/Registrierung</h3>
                  <div className="space-y-3 text-gray-700">
                    <p><strong>Erhobene Daten:</strong> Unternehmensdaten, Kontaktdaten, Rechnungsadresse, Umsatzsteuer-ID</p>
                    <p><strong>Zweck:</strong> Vertragsabwicklung, Rechnungsstellung, Erfüllung steuerlicher Pflichten</p>
                    <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung), lit. c (rechtliche Verpflichtung)</p>
                    <p><strong>Speicherdauer:</strong> Vertragsdauer + gesetzliche Aufbewahrungsfristen (10 Jahre gem. HGB/AO)</p>
                  </div>
                </section>

                {/* 5. E-Mail-Versand */}
                <section className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    5. E-Mail-Versand (SMTP)
                  </h2>
                  <div className="space-y-4 text-gray-700">
                    <p>Für den Versand von Formulardaten, Bestätigungen und Reports nutzen wir einen SMTP-Dienst:</p>
                    <p><strong>Anbieter:</strong> bergx2.de (Deutscher E-Mail-Provider)</p>
                    <p><strong>Datenübermittlung:</strong> Verschlüsselt über TLS</p>
                    <p><strong>Zweck:</strong> Zustellung von Anfragen, Bestätigungen, Reports</p>
                    <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</p>
                  </div>
                </section>

                {/* 6. Hosting */}
                <section className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    6. Hosting und Server
                  </h2>
                  <div className="space-y-4 text-gray-700">
                    <p><strong>Hosting-Anbieter:</strong> Hetzner Online GmbH</p>
                    <p>Industriestr. 25, 91710 Gunzenhausen, Deutschland</p>
                    <p><strong>Zertifizierung:</strong> ISO 27001 (Informationssicherheit)</p>
                    <p><strong>Serverstandort:</strong> Deutschland</p>
                    <p><strong>Verarbeitete Daten:</strong></p>
                    <ul className="list-disc list-inside ml-4">
                      <li>IP-Adresse (technisch erforderlich für Verbindungsaufbau)</li>
                      <li>Zugriffsdatum und -uhrzeit</li>
                      <li>Browser-Typ und -Version (User-Agent)</li>
                      <li>Übertragene Datenmenge</li>
                    </ul>
                    <p><strong>Zweck:</strong> Bereitstellung der Website, Gewährleistung der IT-Sicherheit</p>
                    <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an sicherer Bereitstellung)</p>
                    <p><strong>Speicherdauer:</strong> Server-Logs werden nach 7 Tagen gelöscht</p>
                    <p><strong>Auftragsverarbeitung:</strong> Mit Hetzner besteht eine Auftragsverarbeitungsvereinbarung gem. Art. 28 DSGVO</p>
                  </div>
                </section>

                {/* 7. GeoIP-Prüfung */}
                <section className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    7. GeoIP-Länderprüfung (EU-Beschränkung)
                  </h2>
                  <div className="space-y-4 text-gray-700">
                    <p>Wir prüfen bei Formulareinreichungen Ihre IP-Adresse, um festzustellen, ob Sie sich in einem EU-Land befinden.</p>
                    <p><strong>Technologie:</strong> MaxMind GeoLite2-Country Datenbank (lokal, keine Datenübermittlung an Dritte)</p>
                    <p><strong>Zweck:</strong> Beschränkung der Online-Registrierung auf EU-Kunden (rechtliche Anforderung)</p>
                    <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. c DSGVO (rechtliche Verpflichtung) und lit. f (berechtigtes Interesse)</p>
                    <p className="text-sm text-gray-600">Die IP-Adresse wird nur für die Länderprüfung verwendet und nicht dauerhaft mit Ihrem Nutzerprofil verknüpft.</p>
                  </div>
                </section>

                {/* 8. Datenspeicherung */}
                <section className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    8. Datenspeicherung
                  </h2>
                  <div className="space-y-4 text-gray-700">
                    <p><strong>Standort:</strong> Hetzner-Rechenzentrum in Deutschland</p>
                    <p><strong>Verschlüsselung:</strong> Daten werden verschlüsselt übertragen (TLS/SSL) und verschlüsselt gespeichert</p>
                    <p><strong>Backup:</strong> Tägliche automatische Backups mit 30-Tage-Aufbewahrung</p>
                    <p><strong>Zugriffskontrolle:</strong> API-Key-Authentifizierung für Admin-Zugriffe</p>
                  </div>
                </section>

                {/* 9. Ihre Rechte */}
                <section className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    9. Ihre Rechte als Betroffener
                  </h2>
                  <div className="space-y-4 text-gray-700">
                    <p>Sie haben nach der DSGVO folgende Rechte:</p>
                    <ul className="list-disc list-inside ml-4 space-y-2">
                      <li><strong>Auskunft</strong> (Art. 15 DSGVO) – Über die zu Ihrer Person gespeicherten Daten</li>
                      <li><strong>Berichtigung</strong> (Art. 16 DSGVO) – Korrektur unrichtiger Daten</li>
                      <li><strong>Löschung</strong> (Art. 17 DSGVO) – „Recht auf Vergessenwerden"</li>
                      <li><strong>Einschränkung</strong> (Art. 18 DSGVO) – Sperrung der Verarbeitung</li>
                      <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO) – Erhalt Ihrer Daten in strukturiertem Format</li>
                      <li><strong>Widerspruch</strong> (Art. 21 DSGVO) – Gegen Verarbeitung auf Basis berechtigter Interessen</li>
                      <li><strong>Beschwerde</strong> (Art. 77 DSGVO) – Bei einer Datenschutz-Aufsichtsbehörde</li>
                    </ul>
                    <p className="mt-4">
                      <strong>Kontakt:</strong> Zur Ausübung Ihrer Rechte wenden Sie sich bitte an{' '}
                      <a href="mailto:info@idaki.de" className="text-blue-600 hover:underline">info@idaki.de</a>
                    </p>
                  </div>
                </section>

                {/* 10. Datenweitergabe */}
                <section className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    10. Weitergabe an Dritte
                  </h2>
                  <div className="space-y-4 text-gray-700">
                    <p>Eine Weitergabe Ihrer Daten erfolgt nur in folgenden Fällen:</p>
                    <ul className="list-disc list-inside ml-4 space-y-2">
                      <li><strong>Auftragsverarbeiter:</strong> Hetzner AG (Hosting), bergx2.de (E-Mail-Versand)</li>
                      <li><strong>Rechtliche Verpflichtung:</strong> Wenn gesetzlich vorgeschrieben (z.B. Strafverfolgung, Finanzbehörden)</li>
                      <li><strong>Keine Drittlandübermittlung:</strong> Alle Daten verbleiben in Deutschland/EU</li>
                    </ul>
                    <p className="border-l-4 border-gray-300 p-3 text-sm text-gray-700">
                      <strong>Wichtig:</strong> Wir verkaufen oder vermieten Ihre Daten niemals an Dritte zu Marketingzwecken.
                    </p>
                  </div>
                </section>

                {/* 11. Datensicherheit */}
                <section className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    11. Datensicherheit
                  </h2>
                  <div className="space-y-4 text-gray-700">
                    <p>Wir setzen technische und organisatorische Maßnahmen ein, um Ihre Daten zu schützen:</p>
                    <ul className="list-disc list-inside ml-4 space-y-2">
                      <li>SSL/TLS-Verschlüsselung für alle Datenübertragungen</li>
                      <li>API-Key-Authentifizierung für Admin-Zugriffe</li>
                      <li>Regelmäßige Sicherheitsupdates</li>
                      <li>ISO 27001-zertifizierter Hosting-Partner</li>
                      <li>Zugriffsbeschränkung auf autorisiertes Personal</li>
                      <li>Verschlüsselte Datenbank-Backups</li>
                    </ul>
                  </div>
                </section>

                {/* 12. Nutzung der SaaS-Plattform */}
                <section className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    12. Nutzung der SaaS-Plattform IDA
                  </h2>
                  <div className="space-y-4 text-gray-700">
                    <p>Bei Nutzung der IDA-Plattform werden zusätzlich verarbeitet:</p>
                    <ul className="list-disc list-inside ml-4">
                      <li>Nutzerdaten (Login, Rollen, Berechtigungen)</li>
                      <li>Dokumentation, Checklisten, hochgeladene Dateien</li>
                      <li>Protokolldaten (Audit-Logs)</li>
                    </ul>
                    <p><strong>Rolle:</strong> Als SaaS-Anbieter agieren wir als <strong>Auftragsverarbeiter</strong> gem. Art. 28 DSGVO. Sie bleiben <strong>Verantwortlicher</strong> für die von Ihnen eingegebenen Daten.</p>
                    <p><strong>AVV:</strong> Mit jedem Kunden wird eine Auftragsverarbeitungsvereinbarung (AVV) geschlossen. <Link to="/avv" className="text-blue-600 hover:underline">AVV ansehen</Link></p>
                  </div>
                </section>

                {/* 13. Änderungen */}
                <section className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    13. Änderungen dieser Datenschutzerklärung
                  </h2>
                  <div className="space-y-4 text-gray-700">
                    <p>Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an geänderte Rechtslagen oder Änderungen unserer Leistungen anzupassen.</p>
                    <p>Die aktuelle Version finden Sie stets unter <a href="https://idaki.de/datenschutz" className="text-blue-600 hover:underline">idaki.de/datenschutz</a></p>
                  </div>
                </section>

                {/* Kontakt */}
                <div className="border-l-4 border-gray-300 p-6 mt-8">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Fragen zum Datenschutz?</h3>
                  <p className="text-gray-700">
                    Bei Fragen zur Verarbeitung Ihrer Daten oder zur Ausübung Ihrer Rechte wenden Sie sich bitte an:
                  </p>
                  <p className="mt-3 text-gray-900">
                    <strong>E-Mail:</strong> <a href="mailto:info@idaki.de" className="text-teal-700 hover:text-teal-800 transition-colors">info@idaki.de</a><br />
                    <strong>Telefon:</strong> <a href="tel:+4917623943896" className="text-teal-700 hover:text-teal-800 transition-colors">+49 (0) 176 23 94 38 96</a>
                  </p>
                </div>

            </div>
          </div>
        </main>

        <MainFooter />
      </div>
    </>
  );
};

export default DatenschutzPage;
